import { render, staticRenderFns } from "./MdTextarea.html?vue&type=template&id=8650664e&external"
import script from "./MdTextarea.ts?vue&type=script&lang=ts&external"
export * from "./MdTextarea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports